<template>
  <bulkofd-component>
  <b-row class="mt-2 mb-2">          
      <b-col md="4" class="my-1">
        <b-col sm="12" >
        <b-form-group label-cols-sm="3" label="Search" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
              <option :value="false">Asc</option> <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>             
      <!-- <b-col md="4" class="my-1">
        <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col>   -->
       <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalrecords }}</span></b> </p>
              </b-col>    
                   <b-col id="submit" v-if="this.totalrecords>0">  
                 <input type='checkbox' @click='checkAll()' v-model='isCheckAll'  > 
                 <span > Select All </span>
              &nbsp;
             &nbsp;&nbsp;&nbsp;
                 <b-button type="submit" size="md" variant="primary" @click="allocateshipment" >Allocate</b-button>
             
               
               
              </b-col>
    </b-row> 
    <b-row>
      <b-col md="12">
        <b-col sm="12" >
      <b-table show-empty stacked="md"  :items="items"  :fields="fields"  :current-page="currentPage"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy" >
         
             <template slot="select" slot-scope="row">
    <b-form-group>
       <input class="shipmentscheckbox" type="checkbox"  v-bind:value="row.item.shippingid" v-model='languages' @change='updateCheckall()'/>
    </b-form-group>


     <template slot="shippingid" slot-scope="row">
        {{ row.item.shippingid}}
         

         <span class="badge badge-primary badge-pill" v-if="row.item.orderflow=='Reverse'  ">{{ row.item.orderflow}}</span>
 
         <span class="badge badge-primary badge-pill"  v-if="row.item.istrybuy=='1' && row.item.orderflow !='Reverse'">istrybuy</span>
      
         </template>
  
  </template>

         <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>     
      </b-table> 
    </b-col>
    </b-col>
    <!--   <b-col md="6" class="my-1" v-if="this.totalrecords > 10">
        <b-pagination
              v-model="currentPage"
              :total-rows="totalrecords"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
      </b-col>  -->
    </b-row>  
</bulkofd-component>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
  data: function() {
    return {
      ofd:[],
      items:[],
      isBusy: false,
      fields: [
          {key:'select',label:'Select'},
          { key: 'shippingid', label: 'AWB', sortable: true, sortDirection: 'desc' },
          { key: 'pickuplocationaddress', label: 'Pickup Address', sortable: true},
          { key: 'shipaddress1', label: 'Delivery Address', sortable: true},
          { key: 'agentname', label: 'SR Name', sortable: true},
          { key: 'deliveryagentmobilenumber', label: 'Mobile Number', sortable: true},               
              
          { key: 'lastmodifieddate', label: 'Date', sortable: true }
      ],
      outlined: true,
      totalRows: 10,
      totalrecords:0,
      currentPage: 1,
     // perPage:  10,
      languages: [],
      //pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      isCheckAll: false,
     
      filter: null
    }
  },
  props:["delivery_agentfrom","delivery_agentto"],
  computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
  },
  created: function() {
    this.getofdShipment()
  },
  mounted () {
  },

  methods: {
      info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },

      checkAll: function(){

      this.isCheckAll = !this.isCheckAll;
      this.languages = [];
      // console.log(this.items[0].shippingid);
      if(this.isCheckAll){ // Check all
        for (var key in this.items) {
          this.languages.push(this.items[key].shippingid);
          
        }
         
      }

      // console.log(this.languages);

    },
    updateCheckall: function(){
       
      if(this.languages.length == this.items.length){
         this.isCheckAll = true;
      }else{
         this.isCheckAll = false;
      }
    },
    //    clear: function() {
    //   this.items = [];
    //   this.customer = {}
   
    //   var checkall = document.getElementById("checkall");
    //               checkall.style.display = "none";
    //   this.languages = [];
    //   this.isCheckAll = false;            
    // },
      
   
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },




clear()
{

 this.isBusy = true;
      let userData = localStorage.getItem('userData');
      // console.log(userData);
      //  let deliveryagentmasterid = document.getElementById('deliveryagent_from').value; 
     
      let userInfo = JSON.parse(userData);
      //let pincode=JSON.stringify(userInfo.pickuplocationpincode);
      let obj = {
        deliveryagentmasterid: `${this.delivery_agentfrom}`,
        
        status: "OFD"

      }
        this.$http
          .post(
            `${CONSTANTS.API_URL}/GetBulkAllocationStatuswiseList`,obj)
          .then(result => {
             this.isBusy = !this.isBusy;
              if(result.body.returnmsg === "successful"){
                this.assigned = result.body.returnvalue;
                this.items  = result.body.returnvalue;
                this.totalrecords = result.body.returnvalue.length

              }else {
                this.items  = [];
                this.totalrecords = 0
                 this.isCheckAll = false;
                   localStorage.removeItem(this.delivery_agentto)

              }
          })
          .catch(ex => {
            console.log('error', ex)
          })
    },


   allocateshipment: function()
   {
     //this.toggleInfo = !this.toggleInfo


  var deliveryagentmasteridto= document.getElementById('deliveryagent_to').value;
  console.log("&&&&&&&&&&&&&&&&&&&&",this.delivery_agentto)


    if(this.delivery_agentto==""  || this.delivery_agentto=="undefined" || this.delivery_agentto==undefined)
    {

       // Utils.notify('Please select Delivery Agent to assign Shipment.','error');
        this.$fire({
                  text: "Please select Delivery Agent to assign Shipment",
                  type: "warning",
                  timer: 30000
                });
       return false;
    }
    else
    {
      
       //this.toggleInfo = !this.toggleInfo
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)

        // console.log("DAT:"+userInfo);

        var mobilenumber=userInfo.usermobilenumber;
        var selectShipment = document.getElementsByClassName('shipmentscheckbox');
  
        var shippingIds=[];
        var rto={};
// console.log("length:"+selectShipment.length);
          if(selectShipment.length>0)
          {
            for (var i = 0; i < selectShipment.length; i++) {
                if (selectShipment[i].checked == true){
                  shippingIds.push(selectShipment[i].value)
                }
            }
          }

        if(shippingIds.length >0 )
        {

          var rConfirm = confirm("Are you sure to Reallocate Shipment ?");
          if (rConfirm == true) 
          {        


              var submit = document.getElementById("submit");
              submit.style.display = "block";
             
              rto.shippingid=shippingIds;
              
              rto.lastmodifiedby=userInfo.sysemailid; 

              rto.mobilenumber=mobilenumber;
            
              rto.deliveryagentmasterid=`${this.delivery_agentto}`;

             
               this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/ConsignmentMasterReallocation`,rto )
                .then((result) => {
                  // console.log(result.body.returnvalue);
                 
                  if (result.body.returnmsg=== 'Successful') {
                     
                   // Utils.notify('Shipment Alloacted successfully');
                     this.$fire({
                  text: "Shipment Alloacted Successfully",
                  type: "success",
                  timer: 30000
                });
                   this.clear();
                  
                  } 
                  else

                  {
                     // Utils.notify('Allocation Limit reached for the agent','error');
                     this.$fire({
                  text: "Allocation Limit reached for the agent",
                  type: "error",
                  timer: 30000
                });
                  }

                  
                })

                .catch((ex) => {
                  console.log('error-----', ex)
                  
                })
             }   

            }
           
            else
            {

            
              // Utils.notify('please select atlest 1 shipment','error');
               this.$fire({
                  text: "Please Select atlest 1 Shipment",
                  type: "warning",
                  timer: 30000
                });
            }
      } 
    },


    getofdShipment()
    {
      
      let userData = localStorage.getItem('userData');
      let userInfo = JSON.parse(userData);
      console.log("delivery_agentfrom",this.delivery_agentfrom)
      // let deliveryagentmasterid = document.getElementById('deliveryagent_from').value;

      if(this.delivery_agentfrom =="" || this.delivery_agentfrom ==undefined)
      {
         // alert("In");
          return false;
      }
      else
      {
        this.isBusy = true;

            let obj = {
            deliveryagentmasterid: `${this.delivery_agentfrom}`,
            status: "OFD"

            }
            this.$http
              .post(
                `${CONSTANTS.API_URL}/GetBulkAllocationStatuswiseList`,obj)
              .then(result => {
                 this.isBusy = !this.isBusy;
                if(result.body.returnmsg === "successful"){
                    this.ofd = result.body.returnvalue;
                      this.items  = result.body.returnvalue;
                    this.totalrecords = result.body.returnvalue.length
                  }
              else {
                  this.items  = [];
                    this.totalrecords = 0;
                    // var submit = document.getElementById("submit");
                      //  submit.style.display = "none";
               //alert('Records Not available');
              }
              })
              .catch(ex => {
                console.log('error', ex)
              })
         }     
    }
  }
}
</script>
